import React, { Component } from "react";
import auth from "../Auth";
import { TelerikReportViewer } from '@progress/telerik-react-report-viewer';
import BreadCrumbs from "../Shared/BreadCrumbs/BreadCrumbs";
import { getAllReport, getAllReportFile, getReportSearchesByReport, TelerikReporting_SERVICE_URL } from "./Services/DataServices";
import { IDropDownModel } from "../Shared/Models/IDropDownModel";
import withValueField from "../Shared/withValueField";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import { ErrorComponent } from "../ReusableComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo, faInfoCircle, faPlay, faUndo } from "@fortawesome/free-solid-svg-icons";
import Collapsible from "react-collapsible";
import './ReportViewer.css';
import Auth from '../Auth';
import ReportSavedSearch from "./Filter/ReportSaveSearch";
import { RemoveSession } from "./Services/ReportHelper";
import { match, createEditor } from "./ReportViewerHelper";
import TelerikViewerWithTopScrollbar from "./TelerikViewerWithTopScrollbar";

const CustomDropDownList = withValueField(DropDownList);
const defaultItemCategory = { name: "Select Category", id: null };
const defaultItemReport = { name: "Select Report", id: null };

export interface IDropDownModelReport {
    id: string;
    name: string;
    description: string;
  }

export interface ReportViewerProps { }
export interface ReportViewerState {
    reports: Array<IDropDownModelReport>;
    originalreports: Array<IDropDownModelReport>;
    reportId?: string;
    reportParameters?: any;
    clientName: string;
    toggleFirst: boolean;
    reportName?: string; 
    reportDescription?: string; 
    runReport?: boolean;
    reportsFile?: Array<IDropDownModel>;
    originalReportsFile?: Array<IDropDownModel>;
    reportFileName?: string;
    reportFileId?: string;
    viewerKey?: string;
    flag?: boolean;
    disableSearch?: boolean;
    clientId?: string;
    savedReportSearches?: any;
}

class ReportViewer extends Component<ReportViewerProps, ReportViewerState> {
    childRef: React.RefObject<ReportSavedSearch> = React.createRef();
    viewerRef: React.RefObject<any>;

    constructor(props: ReportViewerProps) {
        super(props);
        this.viewerRef = React.createRef();
        this.state = {
            clientName: auth.getClientName(),
            reports: [],
            originalreports: [],
            toggleFirst: true,
            runReport: false,
            reportsFile: [],
            originalReportsFile: [],
            viewerKey: null,
            flag: false,
            disableSearch: true,
            reportParameters: '',
            reportName: null,
            savedReportSearches: [],
            reportDescription: null
        }
        this.handleFilterChange = this.handleFilterChange.bind(this);
    }

    async componentDidMount() {
        this.getAllReportsFile();
        this.childRef.current.setSelectedData([]);
    }

    getAllReports = (folder) => {
        getAllReport(folder, true).then((res:any) => {
          this.setState({
            reports: res.data.map(file => ({
                name: file.reportName, 
                id: file.reportUri,                
                description: file.description
            })),
            originalreports: res.data.map(file => ({
                name: file.reportName, 
                id: file.reportUri,                
                description: file.description
            }))
          });
        });
    };

    getAllReportsFile = () => {
        getAllReportFile(true).then((res) => {
            this.setState({
                reportsFile: res.data.folders.map((data) => ({
                    name: data.name,
                    id: data.uri
                })),
                originalReportsFile: res.data.folders.map((data) => ({
                    name: data.name,
                    id: data.uri
                }))
            });
        });
    };

    handleReportChange = (e) => {
        this.setState({ reportName: '' });
        const id = e.target.value;
        const selectedReport = this.state.reports.find(report => report.id === id);

        this.setState({
            reportId: id,
            reportName: selectedReport ? selectedReport.name : '',
            reportDescription: selectedReport ? selectedReport.description : '',
            disableSearch: true,
            savedReportSearches: []
        });
        this.childRef.current.defaultSearch();

    }

    handleReportFileChange = (e) => {
        if (!e.target.value) {
            this.setState({
                reportId: null,
                reportName: null,
                reports: [],
                reportFileId: null,
                reportFileName: null,
                disableSearch: false,
                reportDescription: null
            })
            return;
        }
        this.setState({
            reportId: null,
            reportName: null,
            reports: [],
            reportDescription: null
        });
        const id = e.target.value;
        const selectedReportName = e.target.value;
        this.setState(
            {
                reportFileName: selectedReportName,
                reportFileId: id,
                disableSearch: true,
                savedReportSearches: []
            },
            () => {
                this.getAllReports(this.state.reportFileName);
                this.childRef.current.defaultSearch();
            }
        );
    };

    handleFilterChange(event) {
        var name = event.target.props.id;
        var originalArray = "original" + name;
        this.state[name] = this.filterData(event.filter, originalArray);
        this.setState(this.state);
    }

    filterData(filter, originalArray) {
        const data1 = this.state[originalArray];
        return filterBy(data1, filter);
    }

    onCollapseOpen = () => {
        this.setState({
            toggleFirst: true
        });
    };

    onCollapseClose = () => {
        this.setState({
            toggleFirst: false
        });
    };

    handleClear = () => {
        this.setState({
            reportId: null,
            reportName: null,
            reportFileId: null,
            reports: [],
            reportFileName: null,
            runReport: false,
            disableSearch: true,
            savedReportSearches: [],
            reportDescription: null
        });

        this.childRef.current.defaultSearch();
        RemoveSession();
    }

    handleRunReport = () => {
        RemoveSession();
        this.getSavedReportSearches(this.state.reportName);
        this.setState({ runReport: true, viewerKey: this.state.reportId, flag: true });

    }

    removeExtension = (e) => {
        return e.slice(0, -5);
    }

    getSavedReportSearches = (reportId?: any, reportSearchId?: any) => {
        getReportSearchesByReport(reportId).then((res) => {
            this.setState({ savedReportSearches: res.data }, () => {
                // add check for pinned searches
                this.childRef.current.pinnedValue(res.data, reportSearchId)
            });
            let pinnedData = res.data.filter((i) =>
                i.pinned === true ? i : null
            );
            if(reportSearchId!=null){
                let updatedData = res.data.filter((i) =>
                    i.reportSearchId === reportSearchId ? i : null
                );
                this.selectSearch(updatedData);
            }else{
            this.selectSearch(pinnedData);
            }
        })
            .then(() => {
                this.setState({
                    runReport: true, viewerKey: this.state.reportId,
                    flag: true, disableSearch: false
                });
            });
    };

    selectSearch = (data, isRunReport?) => {

        if (isRunReport) {
            RemoveSession();
            this.setState({
                runReport: false, viewerKey: null });
        }

        if (data != undefined && data != null && data.length > 0) {
            let parsedEditableData = data[0].filter ? JSON.parse(data[0].filter).reportSource : data;

            let reportData = {
                parameterValues: (parsedEditableData).parameters,
            };

            this.setState({ reportParameters: reportData.parameterValues });
            this.childRef.current.setSelectedData(data);

        } else {
            this.setState({ reportParameters: null });
            this.childRef.current.setSelectedData([]);
        }

        if (isRunReport) {
            //RemoveSession();
            setTimeout(() => this.setState({
                runReport: true, viewerKey: this.state.reportId,
                flag: true, disableSearch: false
            }), 500);            
        }
    }

    render() {
        const { reportName, reports, reportId, originalreports, reportsFile, originalReportsFile, reportFileId, disableSearch, reportParameters } = this.state;
        const userTriggerName = (
            <span>
                Reporting
            </span>
        );
        // Custom toolbar settings to show only Excel export
        const viewerOptions = {
            toolbar: {
                exportOptions: {
                    pdf: false,
                    excel: true,  // Only allow Excel export
                    word: false,
                    pptx: false,
                    csv: false,
                    html: false,
                    xml: false,
                    mhtml: false,
                },
            },
        };
        return (
            <div className="col-11 mx-auto pl-0 pr-0">
                <div className="container-fluid mt-2 mb-3">
                    <div className="row pt-2 pb-2 mt-3 accordianTitleClr mx-auto mb-2">
                        <div className="col-12 fonFifteen paddingLeftandRight"><BreadCrumbs></BreadCrumbs></div>
                    </div>
                </div>
                <div className="container-fluid mt-3 mb-6 reportViewer">
                    <Collapsible
                        trigger={userTriggerName}
                        open={this.state.toggleFirst}
                        onTriggerOpening={() => this.setState({ toggleFirst: true })}
                        onTriggerClosing={() => this.setState({ toggleFirst: false })}
                        className="">
                        <div className="container-fluid px-0">
                            <div className="myOrderContainer global-action-grid mt-1">
                                <div className="row">
                                    <div className="col-12 col-sm-3 mt-1 mt-sm-0">
                                        <label className="mb-0 font-weight-bold required">Category</label>
                                        <CustomDropDownList
                                            className="form-control mt-1"
                                            data={reportsFile}
                                            textField="name"
                                            valueField="id"
                                            id="reportsFile"
                                            name="id"
                                            value={reportFileId}
                                            defaultItem={defaultItemCategory}
                                            onChange={(e) => this.handleReportFileChange(e)}
                                            filterable={originalReportsFile.length > 5}
                                        />
                                        {(this.state.flag == true && (reportFileId == undefined || reportFileId == null)) && <ErrorComponent />}
                                    </div>
                                    <div className="col-12 col-sm-4 mt-1 mt-sm-0 info-parent">
                                        <label className="mb-0 font-weight-bold required">Report</label>
                                        <CustomDropDownList
                                            className="form-control mt-1"
                                            data={reports}
                                            textField="name"
                                            valueField="id"
                                            id="reports"
                                            name="id"
                                            value={reportId}
                                            defaultItem={defaultItemReport}
                                            onChange={(e) => this.handleReportChange(e)}
                                            filterable={originalreports.length > 5 ? true : false}
                                            onFilterChange={this.handleFilterChange}
                                            disabled={!this.state.reportFileName}
                                        />
                                        <span className="info-icon"> <FontAwesomeIcon icon={faInfoCircle} title={this.state.reportDescription} className="info-icon mr-1 active-icon-blue ClockFontSize" /></span>
                                        {(this.state.flag == true && (reportId == undefined || reportId == null)) && <ErrorComponent />}
                                    </div>
                                    <div className="col-12 col-sm-5 mt-1 mt-sm-0">
                                        <div className="mt-3 justify-content-center border-0 float-right">
                                            <div className="row mt-2 mb-2 ml-0 mr-0">
                                                <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={() => { this.handleClear() }}>
                                                    <FontAwesomeIcon icon={faUndo} className={"mr-1"} /> Clear
                                                </button>
                                                <button type="submit" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0"
                                                    onClick={() => { this.handleRunReport() }}
                                                    disabled={!this.state.reportName}>
                                                    <FontAwesomeIcon icon={faPlay} className={"mr-1"} /> Run
                                                </button>
                                                {(<ReportSavedSearch
                                                    reportName={this.state.reportName}
                                                    reportId={this.state.reportId}
                                                    disableSearch={disableSearch}
                                                    ref={this.childRef}
                                                    viewerRef={this.viewerRef.current}
                                                    selectSearch={this.selectSearch}
                                                    getSavedReportSearches={this.getSavedReportSearches}
                                                    savedReportSearches={this.state.savedReportSearches}
                                                />)}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Collapsible>
                    {this.state.runReport && (
                        
<TelerikViewerWithTopScrollbar
  id={this.state.viewerKey}
  viewerKey={this.state.viewerKey}
>

                        <TelerikReportViewer
                            id={this.state.viewerKey} // Remount if reportName changes
                            key={this.state.viewerKey} // Remount if reportName changes
                            ref={this.viewerRef}
                            serviceUrl={TelerikReporting_SERVICE_URL()}
                            authenticationToken={Auth.getAccessToken()}
                            reportSource={{
                                report: `${reportId}`, // Dynamic report name
                                parameters: reportParameters, // Dynamic report parameters
                                parameterValues: reportParameters, // Dynamic report parameters
                            }}
                            viewMode="PRINT_PREVIEW"
                            viewerContainerStyle={{
                                height: '100vh', // Take the full available height
                                overflow: 'auto', // Allow scrolling if content overflows
                                fontFamily: "ms sans serif",
                                zIndex: 1, // Ensure the viewer is above other elements if necessary
                                width: "100%"
                            }}
                            persistSession={true} // Boolean for filter persistence
                            scaleMode="SPECIFIC"
                            scale={1.2}
                            enableAccessibility={false}
                            viewerOptions={viewerOptions} // Pass custom toolbar settings here
                            keepSessionAlive={true}
                            parameterEditors={{
                                match: match,
                                createEditor: createEditor
                            }}
                        />
                        </TelerikViewerWithTopScrollbar>
                    )}
                </div>
            </div>
        );
    }
}

export default ReportViewer;